<template>
    <CFormSelect
        :model-value="cSelectFormatValue"
        :feedback-invalid="invalidFeedback"
        :invalid="invalid"
        @update:modelValue="updateValue"
    >
        <option
            :value="''"
            :selected="modelValue === null"
        >
            {{ placeholder }}
        </option>
        <template
            v-for="(group, index) in optionGroups"
            :key="index"
        >
            <optgroup :label="group.label">
                <option
                    v-for="option in group.options"
                    :key="option.label"
                    :value="option.value !== null ? option.value : ''"
                    :selected="modelValue === option.value"
                    :hidden="option.hidden"
                >
                    {{ option.label }}
                </option>
            </optgroup>
        </template>
    </CFormSelect>
</template>

<script setup>
import { CFormSelect } from '@coreui/vue-pro'
import { computed } from 'vue'

const props = defineProps({
    isValid: { type: [Boolean, Function], default: null },
    invalidFeedback: { type: String, default: null },
    optionGroups: { default: null, type: Array },
    placeholder: { type: String, default: null },
    modelValue: { default: null, type: [String, Number] }
})

const cSelectFormatValue = computed(() => props.modelValue === null ? null : String(props.modelValue))

const invalid = computed(() => props.isValid === null ? (props.invalidFeedback !== null) : !props.isValid)

const emits = defineEmits(['update:modelValue', 'update:value', 'change'])

function updateValue (event) {
    emits('update:modelValue', event)
    emits('update:value', event)
    emits('change')
}
</script>
